import { render, staticRenderFns } from "./CourseSelectionForm.vue?vue&type=template&id=cef79cce&scoped=true&"
import script from "./CourseSelectionForm.vue?vue&type=script&lang=ts&"
export * from "./CourseSelectionForm.vue?vue&type=script&lang=ts&"
import style0 from "./CourseSelectionForm.vue?vue&type=style&index=0&id=cef79cce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef79cce",
  null
  
)

export default component.exports